import { jsx, jsxs } from "react/jsx-runtime";
const SvgE = (props) => /* @__PURE__ */ jsxs("svg", { "data-name": "Group 12", xmlns: "http://www.w3.org/2000/svg", width: "5.25rem", height: "5.25rem", viewBox: "0 0 200 200", ...props, children: [
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a3qfcei01a", children: /* @__PURE__ */ jsx("path", { "data-name": "Rectangle 20", d: "M0 0h200v200H0z" }) }) }),
  /* @__PURE__ */ jsx("g", { "data-name": "Group 11", style: {
    clipPath: "url(#a3qfcei01a)"
  }, children: /* @__PURE__ */ jsx("path", { "data-name": "Path 6", d: "M200 100A100 100 0 1 1 100 0a100 100 0 0 1 100 100" }) })
] });
export default SvgE;
